import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Col, Row, Typography } from 'antd';
import React, { useState } from 'react';
import { IOrderHeaderCardsProps } from './OrderHeaderCards.props';

const { Text } = Typography;

export const OrderHeaderCardsPresentation: React.FC<IOrderHeaderCardsProps> = ({
  jobCard,
  customerCard,
  invoiceCard,
}) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <div style={{ background: '#fafcff' }}>
      <div
        style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', padding: '8px 0' }}
        onClick={() => setExpanded((prev) => !prev)}
      >
        <Text type="secondary" strong style={{ fontSize: 14 }}>
          Order details
        </Text>
        {expanded ? <UpOutlined style={{ fontSize: 10, color: '#8c8c8c' }} /> : <DownOutlined style={{ fontSize: 10, color: '#8c8c8c' }} />}
      </div>
      {expanded && (
        <Row gutter={[8, 16]} style={{ margin: '0 8px' }}>
          <Col span={8}>
            <Text type="secondary" strong style={{ fontSize: 13 }}>Job card details</Text>
            {jobCard}
          </Col>
          <Col span={8}>
            <Text type="secondary" strong style={{ fontSize: 13 }}>Customer & vehicle details</Text>
            {customerCard}
          </Col>
          <Col span={8}>
            <Text type="secondary" strong style={{ fontSize: 13 }}>Invoice details</Text>
            {invoiceCard}
          </Col>
        </Row>
      )}
    </div>
  );
};
